export default "https://legacy.eskolare-development.com/images/timeout.png";